<template>
  <div class="splash-screen-container" >
    <v-container class="splash ma-0 pa-0" >
      <v-row class="splash-main">
        <v-carousel
          v-model="currentSlide"
          :show-arrows="images.length > 1"
          :cycle="false"
          class="carousel"
          height="85vh" 
          hide-delimiter-background
          :hide-delimiters="images.length < 2"
        >
        <template v-slot:prev="{ props }">
          <btn class="v-btn v-btn--icon v-btn--density-default v-btn--size-default switch-image-button"
            @click="props.onClick"
          ><v-icon class="switch-image-button-icon" left>mdi-chevron-left</v-icon>
          </btn>
        </template>
        <template v-slot:next="{ props }">        
          <btn class="v-btn v-btn--icon v-btn--density-default v-btn--size-default switch-image-button"
            @click="props.onClick"
          ><v-icon class="switch-image-button-icon" right>mdi-chevron-right</v-icon>
          </btn>
        </template>
          <v-carousel-item
            v-for="(image, i) in images"
            :key="i"
          >
            <a
              v-if="image.mediaClickableLink"
              :href="image.mediaClickableLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-img
                class="carousel-image"
                :src="image.src"
                :alt="image.mediaAlternativeText || t('playlist.imageAlt', { n: i + 1 })"
                @load="onImageLoad"
              />
            </a>
            <v-img
              v-else
              class="carousel-image"
              :src="image.src"
              :alt="image.mediaAlternativeText || t('playlist.imageAlt', { n: i + 1 })"
              @load="onImageLoad"
            />
          </v-carousel-item>
          <v-overlay
            :scrim="false"
            content-class="w-100 h-100 d-flex flex-column align-center justify-space-between pointer-pass-through py-3"
            contained
            model-value
            no-click-animation
            persistent
          >
          </v-overlay>
        </v-carousel>
      </v-row>
      <v-row class="splash-footer" align="center" justify="center">
      <v-col v-if="notSeenCurrentSplashScreen" class="ma-0 pa-0" cols="8" >
        {{ t('playlist.departuresDisplayedIn') }}
        <span style="font-weight: bold"> {{ t('playlist.seconds', { n: closePlaylistCarouselTimeOut }, closePlaylistCarouselTimeOut) }}</span>
      </v-col>
      <v-col v-else class="ma-0 pa-0" cols="4" >
        {{ t('playlist.goToDepartures') }}
      </v-col>
      <v-col cols="4" class="ma-0 splash-btn-container">
        <v-img
          @click="closePlaylistCarousel"
          :src="disableButton ? disabledSkipImage : enabledSkipImage"
          :aria-label= "ariaSkipButton"
          :alt="ariaSkipButton"
          class="mx-auto splash-skip-btn-image"
          :class="disableButton ? 'disabled-button-image' : ''"
        />
      </v-col>
    </v-row>
    </v-container>
  </div>
</template>

<script>
import {  mapMutations, mapGetters, mapActions, mapState } from "vuex";
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {      
      currentSlide: 0,
      loadedImages: 0,
      enabledSkipImage: require("@/assets/icons/skipBtn.svg"),
      disabledSkipImage: require("@/assets/icons/closeBtn.svg"),
      
      initialTimeout: 0,      
      closePlaylistCarouselTimeOut: 0,
      dismissPlaylistCarouselTimer: null,

      
      disabledDismissButtonTime: 0,

      alreadyViewedTimer: null,

      initialDisabled: false,
      disableButton: false,
    };
  },
  mounted() {
    this.initialDisabled = process.env.VUE_APP_PLAYLIST_SCREEN_DISABLED_SKIP_BUTTON === "true";
    this.disableButton =
      (this.initialDisabled && !this.splashScreenViewed) &&
      (this.initialDisabled && !this.splashIdSameCookieValue);
    
    this.disabledDismissButtonTime = parseInt(process.env.VUE_APP_PLAYLIST_SCREEN_DISABLE_DISMISS_TIMER || '5', 10);

    this.scheduleSlideTransition();

    this.closePlaylistCarouselTimeOut = (this.images ?? []).reduce((sum, item) => sum + item.duration, 0);
    if(this.closePlaylistCarouselTimeOut > 0 && this.notSeenCurrentSplashScreen) this.startdismissPlaylistCarouselTimer();
  },
  unmounted() {
    clearTimeout(this.imageScheduleTimer);
    clearInterval(this.dismissPlaylistCarouselTimer);
  },
  computed: {
    ...mapGetters(["cookiePreference", "splashIdSameCookieValue", "notSeenCurrentSplashScreen"]),
    ...mapState(["splashScreenViewed", "playlist", "splashScreenIdLastViewed"]),    
    images() {
      return this.playlist?.playlistItems ?? [];
    },
    splashScreenMessageAriaLabel() {
      return this.t('playlist.splashScreenMessage', { seconds: this.closePlaylistCarouselTimeOut });
    },
    ariaSkipButton() {
      return this.disableButton
        ? this.t('playlist.skipButtonDisabled', { seconds: this.disabledDismissButtonTime })
        : this.t('playlist.skipButton');
    }
  },
  methods: {    
    ...mapMutations(["setSplashScreenIdLastViewed","setDisableMenu"]),
    ...mapActions(["updateCurrentPage", "updateSplashScreenViewed"]),

    onImageLoad() {
      this.loadedImages++;
  },

    //checks if images have loaded if not recalls itself
    //once images have loaded it sets timeout for the next image
    scheduleSlideTransition() {
      if (this.images && this.images.length > 0)
      {
        const duration = this.images[this.currentSlide].duration;

        this.imageScheduleTimer = setTimeout(() => {
          this.currentSlide = (this.currentSlide + 1) % this.images.length;
          this.scheduleSlideTransition();
        }, duration * 1000);
      } else {
        this.imageScheduleTimer = setTimeout(() => {
          this.scheduleSlideTransition();
        }, 1 * 1000);
      }
    },
    closePlaylistCarousel() {
      if (this.disableButton) return;
      this.updateCurrentPage("timetable");
      this.updateSplashScreenViewed()
      this.setDisableMenu(false);
      if (this.cookiePreference) {
        this.setSplashScreenIdLastViewed(this.playlist.id);
      }
    },
    startdismissPlaylistCarouselTimer() {
      this.dismissPlaylistCarouselTimer = setInterval(() => {
        this.closePlaylistCarouselTimeOut--;
        this.disabledDismissButtonTime--;
        if (this.closePlaylistCarouselTimeOut <= 0) {
          this.closePlaylistCarousel();
        }
        if (this.disabledDismissButtonTime <= 0) {
          this.disableButton = false;
        }
      }, 1000);
    },
  },
};
</script>
<style>
.v-btn--size-default {
  margin:10px;
}

.switch-image-button {
  border:#ffffff90 1px solid !important;
  background-color: #55555581 !important;  
}

.switch-image-button-icon{
  color:#ffffff90 !important;
}

.v-img__img--contain {
  max-height: 85vh;
}
.disabled-skip-image {
  opacity: 0.5;
}
.splash-skip-btn-image {
  
  z-index:99999;
  width: 80%;
}
.v-btn__underlay {
  display: none !important;
}
.splash-btn-container{
  z-index:99999;
  height: 80%;
  padding: 0px !important;
  margin:0px !important;
}
.skip-btn {
  padding: 0 !important; 
  border-radius: 50% !important; 
  overflow: hidden !important; 
}
.skip-btn img {
  object-fit: cover; 
}
.WMBusImg {
  position: absolute;
  bottom: 0;
  right: 0;
}
.vehicle-icon {
  float: right;
  font-size: 36px !important;
  color: red;
  background: white;
  border-radius: 10%;
}
.splash {
  max-width: 100% !important;
  background-color: rgb(var(--v-theme-splash-footer)) !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.splash-header {
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  font-size: 24px;
  padding: 20px;
  border: 25px;
  margin-left: 20px;
  margin-right: 20px;
}
.splash-main {  
  display: flex;
  justify-content: center;  /* horizontal center */
  align-items: center;      /* vertical center */
  left: 0;
  width: 100%;
  margin: 0px !important;
  background: rgb(var(--v-theme-splash-footer)) !important;
  color: white;
  padding: 0px;
  margin: 0px !important;
}
.splash-footer {
  position: fixed;
  vertical-align: center;
  bottom: 0px;
  left: 0;
  right: 0;
  padding: 20px;
  border: 25px;
  margin: 0px !important;
  background: rgb(var(--v-theme-splash-footer));
  color: rgb(var(--v-theme-background)) !important;
  height: 15vh;
  z-index:99999;
}

.splash-screen-loading-img {
  background: gray;
  width:100%;
  max-width:350px;
  padding: 10px;
}

.splash-screen-loading-div {
  width:100%;
  height:100%;
  background-color: gray;
  display: flex;
  justify-content: center;  /* horizontal center */
  align-items: center;      /* vertical center */
}
@media (orientation: landscape) {
  .splash-footer {
    padding: 3px;
    z-index: 1001;
  }
  .mx-auto {
    max-height: 80%;
  }

}
.v-overlay__content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.splash-card {
  height: 85vh;
}
.close-splash-button {
  color: white;
  background-color: rgb(150, 0, 0);
  z-index: 1002;
}
.play-list {
  height: 85vh;
  z-index: 1000;
}
.carousel{
  height:100%;
}
.splash-screen-container {
  background: rgb(var(--v-theme-splash-footer));
}
.carousel-with-top-delimiters >>> .v-carousel__controls {
  top: 0;
  bottom: auto;
  position: absolute;
}
.carousel-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>